import EngineReport from '../assets/images/reports/engineReport.svg';
import Service from '../assets/images/reports/service.svg';
import Traffic from '../assets/images/reports/traffic.svg';
import Onboard from '../assets/images/reports/onboard.svg';
import Transmition from '../assets/images/reports/transmition.svg';

export const ValidationContainer = {
  carNumber: /^[A-Z0-9]*\d[A-Z0-9]$/,
  mobileNumberFormat: /^[6789]\d{9}$/,
  alphabet: /[A-Z]/,
};

export const healthReportData = [
  {
    icon: EngineReport,
    title: 'Engine Inspection report',
    description:
      'Detailed Overall inspection of the car internal parts and paintings.',
    reportLink: '/report-details',
    module_id: 1,
    unlocked: true,
  },
  {
    icon: Transmition,
    title: 'Transmission inspection report',
    description:
      'Complete detailed inspection report about car gearbox, clutch & gear oil.',
    reportLink: '/report-details',
    unlockLink: '/payment',
    unlockPrice: 'Unlock for ₹299',
    module_id: 2,
    unlocked: true,
  },
  {
    icon: Onboard,
    title: 'OBD Report',
    description:
      'Car detailed health report of sensors, and onboard electronics of car.',
    reportLink: '/report-details',
    unlockLink: '/payment',
    unlockPrice: 'Unlock for ₹499',
    module_id: 3,
    unlocked: false,
  },
  {
    icon: Traffic,
    title: 'Traffic Fines and Blacklist Details',
    description:
      'Get to know the car fines, blacklist status & many more legal info of car.',
    reportLink: '',
    unlockLink: '',
    module_id: 4,
    unlocked: false,
  },
  {
    icon: Service,
    title: 'Finance and insurance check',
    description: 'Complete service history of car in one glance.',
    reportLink: '',
    unlockLink: '',
    unlocked: false,
    module_id: 5,
  },
];
export const comingSoon = [
  {
    icon: Traffic,
    title: 'Traffic fines & blacklist details',
    description:
      'Get to know the car fines, blacklist status & many more legal info of car.',
    reportLink: '',
    unlockLink: '',
    unlockPrice: 'Coming Soon',
    unlocked: false,
  },
  {
    icon: Service,
    title: 'Service history',
    description: 'Complete service history of car in one glance.',
    reportLink: '',
    unlockLink: '',
    unlockPrice: 'Coming Soon',
    unlocked: false,
  },
];
export const checkoutEngine = [
  { title: 'Oil Pump', warranty: true, service: false, superCombo: true },
  {
    title: 'Crankshaft & Pulley',
    warranty: true,
    service: true,
    superCombo: true,
  },
  {
    title: 'Big end and main bearings',
    warranty: true,
    service: true,
    superCombo: true,
  },
  {
    title: 'Connecting rods',
    warranty: true,
    service: false,
    superCombo: '',
  },
  { title: 'Gudgeon Pins', warranty: true, service: '', superCombo: true },
  {
    title: 'Piston and Rings',
    warranty: true,
    service: '',
    superCombo: true,
  },
  {
    title: 'Inlet and exhaust valves',
    warranty: true,
    service: false,
    superCombo: true,
  },
];

export const planDetailsArray = [
  {
    inspectionPackageId: 1,
    tenancy: 6,
    packTitle: 'Basic',
    packCaption: null,
    smallPackage: {
      packageInstanceId: 2,
      packageId: 8,
      costPrice: 933,
      taxPercent: 18,
      validityDays: 365,
      totalPrice: 1100,
      inspectionCount: 1,
      inspectionFeatures: [
        {
          feature_name: 'Engine Health Check & Diagnostic',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Transmission Assessment',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Electrical System Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Mechanical Components Review',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Interior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Exterior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'OBD-2 Diagnostic Report',
          isvalid: 'NO',
        },
        {
          feature_name: 'Engine Control Module Analysis',
          isvalid: 'NO',
        },
        {
          feature_name: 'Body Control Module Inspection',
          isvalid: 'NO',
        },
        {
          feature_name: 'Accident History Inspection',
          isvalid: 'NO',
        },
        {
          feature_name: 'Finance Validity & Clearance Check',
          isvalid: 'NO',
        },
        {
          feature_name: 'Insurance Validity & Expiry Check',
          isvalid: 'NO',
        },
        {
          feature_name: 'Traffic Challans Verification',
          isvalid: 'NO',
        },
        {
          feature_name: 'Vehicle Crime Records Check',
          isvalid: 'NO',
        },
      ],
      addonFeatures: {
        addon_title: 'Additional benfits',
        features: [
          {
            'sub-title': 'Pre-Purchase Support',
            features: [
              {
                name: 'Buying price recommendation',
                isvalid: 'Yes',
              },
              {
                name: 'Repair Estimate',
                isvalid: 'Yes',
              },
              {
                name: 'Discount on insurance purchase',
                isvalid: 'Yes',
              },
            ],
          },
          {
            'sub-title': 'Post-Purchase Support',
            features: [
              {
                name: '60 Days Warranty',
                isvalid: 'No',
              },
              {
                name: '30 Days Buyback Guarantee',
                isvalid: 'No',
              },
              {
                name: 'Insurance claim assistance',
                isvalid: 'No',
              },
            ],
          },
        ],
      },
      isActive: true,
      creationDate: '2024-07-27T07:25:54.000+00:00',
      lastModified: '2024-08-20T13:00:35.000+00:00',
    },
    highPackage: {
      packageInstanceId: 3,
      packageId: 9,
      costPrice: 2288,
      taxPercent: 18,
      validityDays: 365,
      totalPrice: 2700,
      inspectionCount: 3,
      inspectionFeatures: [
        {
          feature_name: 'Engine Health Check & Diagnostic',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Transmission Assessment',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Electrical System Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Mechanical Components Review',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Interior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Exterior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'OBD-2 Diagnostic Report',
          isvalid: 'NO',
        },
        {
          feature_name: 'Engine Control Module Analysis',
          isvalid: 'NO',
        },
        {
          feature_name: 'Body Control Module Inspection',
          isvalid: 'NO',
        },
        {
          feature_name: 'Accident History Inspection',
          isvalid: 'NO',
        },
        {
          feature_name: 'Finance Validity & Clearance Check',
          isvalid: 'NO',
        },
        {
          feature_name: 'Insurance Validity & Expiry Check',
          isvalid: 'NO',
        },
        {
          feature_name: 'Traffic Challans Verification',
          isvalid: 'NO',
        },
        {
          feature_name: 'Vehicle Crime Records Check',
          isvalid: 'NO',
        },
      ],
      addonFeatures: {
        addon_title: 'Additional benfits',
        features: [
          {
            'sub-title': 'Pre-Purchase Support',
            features: [
              {
                name: 'Buying price recommendation',
                isvalid: 'Yes',
              },
              {
                name: 'Repair Estimate',
                isvalid: 'Yes',
              },
              {
                name: 'Discount on insurance purchase',
                isvalid: 'Yes',
              },
            ],
          },
          {
            'sub-title': 'Post-Purchase Support',
            features: [
              {
                name: '60 Days Warranty',
                isvalid: 'No',
              },
              {
                name: '30 Days Buyback Guarantee',
                isvalid: 'No',
              },
              {
                name: 'Insurance claim assistance',
                isvalid: 'No',
              },
            ],
          },
        ],
      },
      isActive: true,
      creationDate: '2024-07-27T07:26:15.000+00:00',
      lastModified: '2024-08-20T13:00:39.000+00:00',
    },
    isActive: true,
    creationDate: '2024-08-13T13:57:45.000+00:00',
    lastModified: '2024-08-13T16:56:59.000+00:00',
  },
  {
    inspectionPackageId: 4,
    tenancy: 6,
    packTitle: 'Premium',
    packCaption: null,
    smallPackage: {
      packageInstanceId: 10,
      packageId: 10,
      costPrice: 1102,
      taxPercent: 18,
      validityDays: 365,
      totalPrice: 1300,
      inspectionCount: 1,
      inspectionFeatures: [
        {
          feature_name: 'Engine Health Check & Diagnostic',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Transmission Assessment',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Electrical System Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Mechanical Components Review',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Interior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Exterior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'OBD-2 Diagnostic Report',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Engine Control Module Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Body Control Module Inspection',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Accident History Inspection',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Finance Validity & Clearance Check',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Insurance Validity & Expiry Check',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Traffic Challans Verification',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Vehicle Crime Records Check',
          isvalid: 'Yes',
        },
      ],
      addonFeatures: {
        addon_title: 'Additional benfits',
        features: [
          {
            'sub-title': 'Pre-Purchase Support',
            features: [
              {
                name: 'Buying price recommendation',
                isvalid: 'Yes',
              },
              {
                name: 'Repair Estimate',
                isvalid: 'Yes',
              },
              {
                name: 'Discount on insurance purchase',
                isvalid: 'Yes',
              },
            ],
          },
          {
            'sub-title': 'Post-Purchase Support',
            features: [
              {
                name: '60 Days Warranty',
                isvalid: 'No',
              },
              {
                name: '30 Days Buyback Guarantee',
                isvalid: 'No',
              },
              {
                name: 'Insurance claim assistance',
                isvalid: 'No',
              },
            ],
          },
        ],
      },
      isActive: true,
      creationDate: '2024-08-02T02:39:53.000+00:00',
      lastModified: '2024-08-20T13:01:09.000+00:00',
    },
    highPackage: {
      packageInstanceId: 11,
      packageId: 11,
      costPrice: 2543,
      taxPercent: 18,
      validityDays: 365,
      totalPrice: 3000,
      inspectionCount: 3,
      inspectionFeatures: [
        {
          feature_name: 'Engine Health Check & Diagnostic',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Transmission Assessment',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Electrical System Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Mechanical Components Review',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Interior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Exterior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'OBD-2 Diagnostic Report',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Engine Control Module Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Body Control Module Inspection',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Accident History Inspection',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Finance Validity & Clearance Check',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Insurance Validity & Expiry Check',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Traffic Challans Verification',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Vehicle Crime Records Check',
          isvalid: 'Yes',
        },
      ],
      addonFeatures: {
        addon_title: 'Additional benfits',
        features: [
          {
            'sub-title': 'Pre-Purchase Support',
            features: [
              {
                name: 'Buying price recommendation',
                isvalid: 'Yes',
              },
              {
                name: 'Repair Estimate',
                isvalid: 'Yes',
              },
              {
                name: 'Discount on insurance purchase',
                isvalid: 'Yes',
              },
            ],
          },
          {
            'sub-title': 'Post-Purchase Support',
            features: [
              {
                name: '60 Days Warranty',
                isvalid: 'Yes',
              },
              {
                name: '30 Days Buyback Guarantee',
                isvalid: 'Yes',
              },
              {
                name: 'Insurance claim assistance',
                isvalid: 'Yes',
              },
            ],
          },
        ],
      },
      isActive: true,
      creationDate: '2024-08-13T15:52:29.000+00:00',
      lastModified: '2024-08-20T13:01:45.000+00:00',
    },
    isActive: true,
    creationDate: '2024-08-13T16:22:17.000+00:00',
    lastModified: '2024-08-25T15:21:06.000+00:00',
  },
  {
    inspectionPackageId: 10,
    tenancy: 6,
    packTitle: 'Luxury',
    packCaption: null,
    smallPackage: null,
    highPackage: {
      packageInstanceId: 12,
      packageId: 12,
      costPrice: 4238,
      taxPercent: 18,
      validityDays: 365,
      totalPrice: 5000,
      inspectionCount: 1,
      inspectionFeatures: [
        {
          feature_name: 'Engine Health Check & Diagnostic',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Transmission Assessment',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Electrical System Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Mechanical Components Review',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Interior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Exterior Evaluation (With Photos)',
          isvalid: 'Yes',
        },
        {
          feature_name: 'OBD-2 Diagnostic Report',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Engine Control Module Analysis',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Body Control Module Inspection',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Accident History Inspection',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Finance Validity & Clearance Check',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Insurance Validity & Expiry Check',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Traffic Challans Verification',
          isvalid: 'Yes',
        },
        {
          feature_name: 'Vehicle Crime Records Check',
          isvalid: 'Yes',
        },
      ],
      addonFeatures: {
        addon_title: 'Additional benfits',
        features: [
          {
            'sub-title': 'Pre-Purchase Support',
            features: [
              {
                name: 'Buying price recommendation',
                isvalid: 'Yes',
              },
              {
                name: 'Repair Estimate',
                isvalid: 'Yes',
              },
              {
                name: 'Discount on insurance purchase',
                isvalid: 'Yes',
              },
            ],
          },
          {
            'sub-title': 'Post-Purchase Support',
            features: [
              {
                name: '60 Days Warranty',
                isvalid: 'Yes',
              },
              {
                name: '30 Days Buyback Guarantee',
                isvalid: 'Yes',
              },
              {
                name: 'Insurance claim assistance',
                isvalid: 'Yes',
              },
            ],
          },
        ],
      },
      isActive: true,
      creationDate: '2024-08-19T02:37:06.000+00:00',
      lastModified: '2024-08-23T02:21:49.000+00:00',
    },
    isActive: true,
    creationDate: '2024-08-20T15:04:14.000+00:00',
    lastModified: '2024-09-05T07:58:51.000+00:00',
  },
];

export const InspectionCardsArray = [
  {
    header: 'Physical / Manual Inspection',
    checkPoints: '135',
    inspectionItems: [
      'Engine & Transmission Check',
      'Electrical Parts Check',
      'Mechanical Parts Check',
      'Interior & Exterior Check',
    ],
    additionalBenifits: [
      'Flood Vehicle Check, Major engine repair check',
      'Battery function check, Odometer Tampering Check',
      'Braking System, Fuel System Check',
    ],
  },
  {
    header: 'RTO & Police Verification',
    checkPoints: '29',
    inspectionItems: [
      'Loan and Insurance Check',
      'Traffic Fines & Blacklist Check',
      'PUC and RC Validity Check',
      'Owners & Vehicle Info Check',
    ],
    additionalBenifits: [
      'Engine failure probability Analysis, Transmission Failure Probability Analysis',
      'Stability driving check at high speeds using Advanced OBD-2 scanner',
      'Expensive Repair prevention check',
    ],
  },
  {
    header: 'Advanced OBD2 Scanner Test',
    checkPoints: '76',
    inspectionItems: [
      'Engine Control Module (ECM)',
      'Transmission Control Module ',
      'Body Control Module (BCM)',
      'Fault Code check and Analysis ',
    ],
    additionalBenifits: [
      'Loan NOC Check, Insurance Expiry Check',
      'Blacklist Status Check',
      'Fraud data and RC Document data verification with Vaahan Database',
    ],
  },
  {
    header: 'Additional Technical Support',
    checkPoints: '76',
    inspectionItems: [
      'Fair Price Estimate',
      'Repair Estimate',
      'Expert Mechanic Advice',
      'Extended Warranty up to 2 years',
    ],
  },
];

export const scheduleTimeArray = [
  {
    id: '08:00:00',
    title: '8 AM',
  },
  {
    id: '09:00:00',
    title: '9 AM',
  },
  {
    id: '10:00:00',
    title: '10 AM',
  },
  {
    id: '11:00:00',
    title: '11 AM',
  },
  {
    id: '12:00:00',
    title: '12 PM',
  },
  {
    id: '13:00:00',
    title: '1 PM',
  },
  {
    id: '14:00:00',
    title: '2 PM',
  },
  {
    id: '15:00:00',
    title: '3 PM',
  },
  {
    id: '16:00:00',
    title: '4 PM',
  },
  {
    id: '17:00:00',
    title: '5 PM',
  },
  {
    id: '18:00:00',
    title: '6 PM',
  },
  {
    id: '19:00:00',
    title: '7 PM',
  },
  {
    id: '20:00:00',
    title: '8 PM',
  },
];

export const inspectionDataString = [
  {
    category_id: 1,
    titile: 'General Information ',
    answered_questions: 0,
    total_questions: 2,
    questionary: [
      {
        questionary_id: 1001,
        questions: {
          question_id: '10011',
          question_description:
            'Does the Vehicle appear to have been in an accident?',
          audio_note_url:
            'https://objectstore.e2enetworks.net/wisedrivestorage/Audiofiles/inspection/Hindi/Q118.mp3',
          photo_note_url: 'PathToFile',
          video_note_url: null,
          select_options: {
            type: 'single_select',
            question_description:
              'Does the Vehicle appear to have been in an accident?',
            choices: [
              { choice: 'Yes', selected: false },
              { choice: 'No', selected: false },
            ],
          },
          uploads: {
            photo: { is_required: false, is_mandatory: false, path: null },
            video: { is_required: false, is_mandatory: false, path: null },
            audio: { is_required: true, is_mandatory: false, path: null },
          },
          sub_question: null,
        },
      },
      {
        questionary_id: 1002,
        questions: {
          question_id: '10021',
          question_description: 'Does the Vehicle appear to be flood-damaged?',
          audio_note_url:
            'https://objectstore.e2enetworks.net/wisedrivestorage/Audiofiles/inspection/Hindi/Q119.mp3',
          photo_note_url: 'PathToFile',
          video_note_url: null,
          select_options: {
            type: 'single_select',
            question_description:
              'Does the Vehicle appear to be flood-damaged?',
            choices: [
              { choice: 'Yes', selected: true },
              { choice: 'No', selected: false },
            ],
          },
          uploads: {
            photo: { is_required: false, is_mandatory: false, path: null },
            video: { is_required: false, is_mandatory: false, path: null },
            audio: { is_required: true, is_mandatory: false, path: null },
          },
          sub_question: null,
        },
      },
    ],
  },
  {
    category_id: 2,
    titile: 'Exterior Inspection',
    answered_questions: 0,
    total_questions: 16,
    questionary: [
      {
        questionary_id: 2004,
        questions: {
          question_id: '20041',
          question_description:
            'Please take Front view photo of vehicle with Registered number',
          audio_note_url:
            'https://objectstore.e2enetworks.net/wisedrivestorage/Audiofiles/inspection/Hindi/Q1.mp3',
          photo_note_url: 'PathToFile',
          video_note_url: null,
          select_options: null,
          uploads: {
            photo: { is_required: true, is_mandatory: true, path: null },
            video: { is_required: false, is_mandatory: false, path: null },
            audio: { is_required: true, is_mandatory: false, path: null },
          },
          sub_question: null,
        },
      },
    ],
  },
];
